import { SearchCategory, SearchProps } from '@components/Navigation/_GlobalSearch';
import { prependSlash } from '@repo/ui/src/components/Anchor/helpers';
import SearchIcon from '@repo/ui/src/components/Icons/SearchIcon';
import useCurrentUrl from '@repo/ui/src/hooks/useCurrentUrl';
import classNames from 'classnames';
import React from 'react';

const getSearchTerm = (form: HTMLFormElement) => new FormData(form).get('searchTerm') as string;

const DropdownSearch = ({
  link = 'search',
  placeholder = 'Search',
  searchCategory = SearchCategory.all,
}: SearchProps) => {
  const { push } = useCurrentUrl();
  const ref = React.useRef<HTMLInputElement>(null);

  const handleSearch = async (term: string) => {
    const queryParams = new URLSearchParams({
      term,
    });
    if (searchCategory !== SearchCategory.all) {
      queryParams.set('type', searchCategory);
    }
    const url = `${prependSlash(link)}?${queryParams}`;
    await push(url);
    ref.current!.value = '';
  };

  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        return handleSearch(getSearchTerm(e.currentTarget));
      }}
      className="tw-relative tw-text-surface-700 tw-pb-1"
    >
      <label htmlFor="searchTerm" className="sr-only">
        {placeholder}
      </label>
      <SearchIcon
        className="tw-absolute tw-inset-y-3 tw-left-6 tw-text-surface-700 tw-w-6"
        aria-hidden="true"
      />
      <input
        type="text"
        name="searchTerm"
        placeholder={placeholder}
        autoComplete="off"
        className={classNames(
          'tw-rounded-[80px] tw-bg-surface-200 tw-border tw-border-surface-450 tw-py-3 tw-pl-15 tw-pr-4 tra-text-web-body-l placeholder:tw-text-text-400 focus:tw-outline-action-300 focus:tw-outline-2 focus-visible:tw-outline tw-w-full',
        )}
        ref={ref}
      />
    </form>
  );
};

export default DropdownSearch;
